import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ISMS } from "../types/SMSTypes";
import { stat } from "fs";

interface ISMSState {
    sms: ISMS[];
    selectedSMS: ISMS | null
    error: string;
    isLoading: boolean;
    smsActionLoading: boolean;
}

const initialState: ISMSState = {
    sms: [],
    selectedSMS: null,
    error: "",
    isLoading: false,
    smsActionLoading: false,
};
export const smsSlice = createSlice({
    name: "sms",
    initialState,
    reducers: {
        userFetching(state) {
            (state.isLoading = true), (state.error = "");
        },

        addSMSLoading(state) {
            state.isLoading = true;
            state.error = "";
        },

        addSMSSuccess(state, action: PayloadAction<ISMS>) {
            state.isLoading = false;
            state.error="";
            state.selectedSMS = action.payload;
        },
        addSMSFailed(state, action: PayloadAction<string>) {
            state.isLoading = false;
            state.error = action.payload;
        },
        
    },
});

export default smsSlice.reducer;
